
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chart-rankings",
      function () {
        return require("private-next-pages/chart-rankings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chart-rankings"])
      });
    }
  